<p-toast key="enrollError"></p-toast>
<section
  class="toggle-form"
  [ngClass]="{ active: isSessionAttendeeSliderOpen }"
>
   <div *ngIf="showLoader" class="loader-overlay">
    <app-spinner [useOverlay]="true"></app-spinner>
  </div>
  <div class="formwrap">
    <div class="Header">
      <h2>
        &nbsp;<b>{{ SliderHeader }}</b>
      </h2>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text closeButton"
        id="SessionAttendeeSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSliderConfirmation()"
      ></p-button>
    </div>
    <div>
      <div *ngIf="errorMessages.length > 0" class="ErrorMessagePlaceHolder">
        <p-messages severity="error">
          <ng-template pTemplate>
            <div class="p-message-wrapper">
              <div>
                <span class="p-message-icon pi pi-times-circle"></span>
                <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
              </div>
              <div>
                <ul>
                  <li *ngFor="let errorText of errorMessages">
                    {{ errorText }}
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
        </p-messages>
      </div>
      <app-session-attendee-panelist
        [SliderHeader]="SliderHeader"
        [sessionAttendeesData]="sessionAttendeesData"
        [minimumPassingScore]="minimumPassingScore"
        [ScoringOption]="ScoringOption"
        [ProficiencyQuiz]="ProficiencyQuiz"
        (checkboxSelection)="getSessionAttendeeData($event)"
        (selectedItems)="getSelectedItems($event)"
        (gradeChangeEvent)="getGradeChange($event)"
        [courseNumber]="courseNumber"
      ></app-session-attendee-panelist>
    </div>
    <div class="grid btnClass p-0 mt-5 ">
      <div class="col-fixed m-0 p-0 btn-width-12-percent">
        <p-button
        styleClass="p-button-outlined"
        label="Enroll Attendees"
        (onClick)="openEnrollAttendeesPopUp()"
        id="enrollAttendees"
        class="enroll-attendees"
        iconPos="left"
      >
      </p-button>
      </div>
      <div class="col-fixed m-0 p-0 ml-3 btn-width-12-percent">
        <p-splitButton
          styleClass="p-button-outlined"
          class="p-splitbutton-menubutton splitBtn"
          label="Participation"
          [model]="Participation"
          [disabled]="splitButtonDisable"
        ></p-splitButton>
      </div>
      <div class="col-fixed m-0 p-0 ml-3 btn-width-12-percent">
        <p-splitButton
          styleClass="p-button-outlined"
          class="p-splitbutton-menubutton splitBtn"
          label="Pass/Fail"
          [model]="PassOrFail"
          [disabled]="splitButtonDisableForPassOrFail"
        ></p-splitButton>
      </div>
    </div>
    <div class="m-3" >
      <p-button
      appPreventDoubleClick
        label="{{ SaveButtonLabel }}"
        id="saveButton"
        class="add-save-button"
        iconPos="left"
        [disabled]="saveButtonDisable"
        (debounceClick)="SaveChanges()"
      ></p-button>
    </div>
  </div>
  <app-session-attendees-enroll-modal (addSessionAttendeesEvent)="updateSessionAttendees()" [existingSessionAttendee]="this.sessionAttendeesData"></app-session-attendees-enroll-modal> 
 
  <app-session-attendee-complete-date
  (isCompleteDateModalVisible)="displayTrainingCompleteDateModal($event)" > 
  
</app-session-attendee-complete-date>
</section>
